import { createSlice } from '@reduxjs/toolkit';
// import type { PayloadAction } from '@reduxjs/toolkit';

export interface RutasState {
    ruta: string
    rutas: Array<string>
}

const initialState: RutasState = {
    ruta: '',
    rutas: [], 
}

export const rutaSlice = createSlice({
    name: 'rutas',
    initialState,
    reducers: {
        setRuta: (state, action) => {
            state.ruta = action.payload
        },
        setRutas: (state, action) => {
            state.rutas = action.payload
        }
    },
})

// Action creators are generated for each case reducer function
export const { 
    setRuta,
    setRutas,
} = rutaSlice.actions

